const POURCENTAGE = 'Pourcentage';

export default function creerIntervenant(client) {
  const intervenant = {
    nomCommercial: client.nomCommercial,
    adressePostale: client.adressePostale,
    modeReglementId: client.modeReglementId,
    modeReglement: client.modeReglement,
    delaiReglementId: client.delaiReglementId,
    delaiReglement: client.delaiReglement,
    delaiReglementDetail: client.delaiReglementDetail,
    tiersId: client.id,
    payeur: false,
    donneurOrdre: false,
    mandataire: false,
    annonceur: false,
    repartition: null,
    titre: null,
    typeRepartition: POURCENTAGE,
    tiers: null,
    compteComptable: client.compteComptable,
    factureParMail: client.factureParMail,
    applicationTva: client.applicationTva,
  };
  return intervenant;
}



// WEBPACK FOOTER //
// ./src/services/devis/ajoutIntervenant/creerIntervenant.js